import { useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { LogOut, LockKeyhole } from "lucide-react";

export default function SubscriptionExpired() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const sub = user?.subscription;

  const onLogout = async () => {
    await logout();
    nav("/login");
  };

  return (
    <div className="min-h-screen bg-zinc-50 grid place-items-center p-5">
      <div className="w-full max-w-md bg-white border border-zinc-200 rounded-2xl p-6 sm:p-8 shadow-sm text-center">
        <div className="mx-auto w-12 h-12 rounded-2xl bg-red-50 text-red-600 grid place-items-center">
          <LockKeyhole size={22} />
        </div>
        <h1 className="mt-5 text-2xl font-bold tracking-tight">Langganan Berakhir</h1>
        <p className="mt-2 text-sm text-zinc-500">
          Akses dashboard dan fitur outlet dikunci sampai langganan diaktifkan kembali.
        </p>

        <div className="mt-6 rounded-xl bg-zinc-50 border border-zinc-200 p-4 text-left text-sm">
          <div className="flex justify-between gap-4">
            <span className="text-zinc-500">Outlet</span>
            <span className="font-medium text-zinc-900 text-right">{user?.email || "Outlet"}</span>
          </div>
          <div className="flex justify-between gap-4 mt-2">
            <span className="text-zinc-500">Status</span>
            <span className="font-semibold text-red-700">EXPIRED</span>
          </div>
          {sub?.expires_at && (
            <div className="flex justify-between gap-4 mt-2">
              <span className="text-zinc-500">Berakhir</span>
              <span className="font-medium text-zinc-900">{new Date(sub.expires_at).toLocaleDateString("id-ID")}</span>
            </div>
          )}
        </div>

        <p className="mt-5 text-sm text-zinc-600">
          Hubungi Super Admin untuk mengaktifkan atau memperpanjang langganan.
        </p>

        <Button variant="outline" className="mt-6 w-full" onClick={onLogout}>
          <LogOut size={14} className="mr-2" /> Keluar
        </Button>
      </div>
    </div>
  );
}
